import CallAfterInactivityService from 'src/services/callAfterInactivityService';

const useCallAfterInactivityService = async (lastMessageId: number, status: boolean) => {
  try {
    const response = await CallAfterInactivityService.updateCallStatus(
      lastMessageId,
      status
    );
    return response;
  } catch (error) {
    console.error('Erro ao buscar status dos leads', error);
    throw error;
  }
};

export default useCallAfterInactivityService;
